import moment from 'moment';
import HTMLRenderer from '../../atoms/htmlRenderer/HTMLRenderer';
import Text from '../../atoms/typography/Text';
import { ColorEnum, FontWeightEnum } from '../../enums';
import styles from './MessageBox.module.css';

interface MessageBoxProps {
    readonly createdAt: string;
    readonly heading?: string;
    readonly body?: string;
}

const parseDateTime = (timestr: string) => {
    const date = moment(timestr);
    if (!date.isValid()) {
        return '-';
    }

    return date.fromNow();
}

const MessageBox = ({
    heading,
    body,
    createdAt,
}: MessageBoxProps) => {
    return (
        <div className={styles.messageBoxContainer}>
            <div className={styles.message}>
                {heading && (
                    <Text
                        weight={FontWeightEnum.Bold}
                    >
                        {heading}
                    </Text>
                )}
                {body && (
                    <p>
                        <HTMLRenderer html={body} />
                    </p>
                )}
                <Text
                    weight={FontWeightEnum.Semibold}
                    color={ColorEnum.Gray400}
                >
                    {parseDateTime(createdAt)}
                </Text>
            </div>
        </div>
    );
}

export default MessageBox;
